<template>
  <div>
    <ContentHeader path-set-type="replace" :path-info="navPathInfo" :show-back="false" />

    <div class="content-container" v-loading="loading">
      <div class="SAP-btn">
        <el-button type="primary" v-if="orderType !== 'logistics'" @click="showBPMStatus">BPM审批流程状态</el-button>
        <el-button type="danger" v-if="orderInfo.poNumber" @click="getSAPStatus">SAP订单收货状态</el-button>
      </div>
      <!-- 订单头部信息 -->
      <div class="order-info-block">
        <div class="order-header">
          <el-button
            v-if="(orderInfo.orderStatus === 300 || orderInfo.orderStatus === 400) && !orderInfo.evaluateFlag && (orderType === 'menu' || orderType === 'printing')"
            class="btn-red-plain"
            size="small"
            style="width: 80px;float:right"
            @click="toEvaluation()"
          >评价</el-button>
          <!-- <el-button
            v-if="(orderInfo.orderStatus === 300 || orderInfo.orderStatus === 400) && orderInfo.evaluateFlag && (orderType === 'menu' || orderType === 'printing')"
            class="btn-red-plain"
            size="small"
            style="width: 80px;float:right"
          >已评价</el-button>-->
          <div class="order-number">订单编号: {{ orderInfo.orderNumber }}</div>
          <div class="order-number" v-if="orderInfo.tradeApplyNumber">trade订单编号: {{ orderInfo.tradeApplyNumber }}</div>
          <div class="order-date">
            下单时间: {{ orderInfo.orderDate | parseTime }}
            <span class="ongoing">此订单已经进行了{{ getInterval(orderInfo.createDate) }}天</span>
            <el-popover placement="right" width="250" trigger="click" v-if="(orderType === 'menu' || orderType === 'printing') && (orderInfo.orderStatus !== 900 && orderInfo.orderStatus !== 400)">
              <div class="EstimateDate">
                <div class="title">根据历史情况,为您预估时间如下:</div>
                <ul>
                  <li>BPM审批预计:{{purchaseEstimate.bpmApproveDay}} 天</li>
                  <li>集单:{{purchaseEstimate.setOrderDay}} 天</li>
                  <li>供应商生产:{{purchaseEstimate.produceDay}} 天</li>
                  <li>物流:{{purchaseEstimate.logisticsDay}} 天</li>
                </ul>
              </div>
              <span class="EstimateDate-detail" slot="reference">?</span>
            </el-popover>
          </div>
          <div class="order-status">订单状态: {{ orderInfo.orderStatusName }}</div>
        </div>
        <OrderStatusStep
          v-if="orderInfo.orderStatus !== 900 && orderType !== 'shopSign' && orderType !== 'logistics'"
          :order-info="orderInfo"
          :order-type="orderType"
        />
      </div>

      <!-- 订单描述 -->
      <div class="order-info-block">
        <el-row>
          <el-col :span="3">
            <div class="block-title">订单描述</div>
          </el-col>
          <el-col :span="21">
            <div class="order-remark">{{ orderInfo.orderDesc }}</div>
          </el-col>
        </el-row>
      </div>

      <!-- NonMenu订单商品信息 -->
      <OrderItemInfoNonMenu v-if="orderType === 'nonMenu'" :order-info="orderInfo" @updateOrder="queryOrderById" />

      <!-- Menu订单商品信息 -->
      <div class="order-info-block" v-else>
        <div class="block-title">商品信息</div>

        <el-table :data="orderInfo.detailList" :show-header="false" border class="order-detail">
          <!-- 第一列区域 -->
          <el-table-column label="图片名称" width>
            <template slot-scope="scope">
              <el-row>
                <el-col :span="6">
                  <div class="item-image">
                    <img :src="getItemImageUrl(scope.row.pocmDTO)" />
                  </div>
                </el-col>
                <el-col :span="18">
                  <div class="item-name">{{ scope.row.itemName }}</div>
                  <div>商品编码: {{ scope.row.itemCode }}</div>
                  <div v-if="scope.row.pocmDTO.isPrints">
                    <div>品牌：{{ getBrandName(scope.row) }}</div>
                    <!-- <div>分类：{{ scope.row.categoryName }}</div> -->
                    <div>分类：{{scope.row.pocmDTO.secondCatalogueName}}</div>
                    <div v-if="scope.row.supplierDTO && scope.row.supplierDTO.supplierName">供应商：{{ scope.row.supplierDTO.supplierName }}</div>
                  </div>
                  <div v-else v-show="orderType !== 'shopSign' && orderType !== 'logistics'">状态: {{ scope.row.detailStatusName }}</div>
                  <div>申请人: {{ scope.row.applyPerson }}</div>
                  <!-- <div v-if="orderType !== 'logistics'">可卖数量：{{ scope.row.pocmDTO.availableQty }}</div>
                  <div v-if="orderType !== 'logistics'">历史下单数量：{{ scope.row.pocmDTO.sumOrder }}</div>-->
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <!-- 第二列区域 -->
          <el-table-column label="详细信息" width="300">
            <template slot-scope="scope">
              <div v-if="!scope.row.pocmDTO.isPrints">
                <div v-if="orderType !== 'logistics'">品牌: {{ getBrandName(scope.row) }}</div>
                <!-- <div v-if="scope.row.categoryName">分类: {{ scope.row.categoryName }}</div> -->
                <div v-if="scope.row.pocmDTO.secondCatalogueName">分类：{{scope.row.pocmDTO.secondCatalogueName}}</div>
                <div
                  v-if="orderType !== 'logistics' && scope.row.supplierDTO && scope.row.supplierDTO.supplierName"
                >供应商: {{ scope.row.supplierDTO.supplierName }}</div>
                <div>
                  mmr12: {{ scope.row.mmr12 }}
                  <span v-if="scope.row.mmr12Name">-</span>
                  {{ scope.row.mmr12Name }}
                </div>
                <div>
                  总账科目: {{ scope.row.ledgerAccount }}
                  <span v-if="scope.row.ledgerAccountName">-</span>
                  {{ scope.row.ledgerAccountName }}
                </div>
                <div v-if="orderType !== 'logistics'">
                  是否库存化:
                  <span v-if="scope.row.subjectCategory === ''">是</span>
                  <span v-else>否</span>
                </div>
              </div>
              <div v-else class="prints-info">
                <div v-if="scope.row.pocmDTO.itemPrintsDTO">
                  <div :title="scope.row.pocmDTO.itemPrintsDTO.materialSpecs">材质要求：{{ scope.row.pocmDTO.itemPrintsDTO.materialSpecs }}</div>
                  <div :title="scope.row.pocmDTO.itemPrintsDTO.printSpecs">印刷要求：{{ scope.row.pocmDTO.itemPrintsDTO.printSpecs }}</div>
                  <div :title="scope.row.pocmDTO.itemPrintsDTO.filmMulch">覆膜方式：{{ scope.row.pocmDTO.itemPrintsDTO.filmMulch }}</div>
                  <div :title="scope.row.pocmDTO.itemPrintsDTO.printMethod">印刷方式：{{ scope.row.pocmDTO.itemPrintsDTO.printMethod }}</div>
                  <div :title="scope.row.pocmDTO.itemPrintsDTO.dieCutting">模切要求：{{ scope.row.pocmDTO.itemPrintsDTO.dieCutting }}</div>
                </div>
                <div v-else>
                  <div>材质要求：</div>
                  <div>印刷要求：</div>
                  <div>覆膜方式：</div>
                  <div>印刷方式：</div>
                  <div>模切要求：</div>
                </div>
                <div>制作周期: {{ scope.row.pocmDTO.productTime }}</div>
                <div>物流周期: {{ scope.row.pocmDTO.deliveryTime }}</div>
                <div>
                  mmr12: {{ scope.row.mmr12 }}
                  <span v-if="scope.row.mmr12Name">-</span>
                  {{ scope.row.mmr12Name }}
                </div>
                <div>
                  总账科目: {{ scope.row.ledgerAccount }}
                  <span v-if="scope.row.ledgerAccountName">-</span>
                  {{ scope.row.ledgerAccountName }}
                </div>
                <div>
                  是否库存化:
                  <span v-if="scope.row.subjectCategory === ''">是</span>
                  <span v-else>否</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <!-- 第三列区域 -->
          <el-table-column label="价格数量">
            <template slot-scope="scope">
              <!-- 其他商品 -->
              <div v-if="!scope.row.pocmDTO.isPrints">
                <div>单价(不含税): ￥{{ getPrice(scope.row) | thousandSymbol}}</div>
                <div
                  class="price-msg"
                  v-if="scope.row.priceUnitQuantity !== 1"
                >(每{{ scope.row.priceUnitQuantity }}个商品{{ getPrice(scope.row) | thousandSymbol}}元)</div>
                <div v-if="orderType !== 'shopSign'">
                  税额:
                  <span v-if="scope.row.pocmPriceType === '01' || !scope.row.pocmPriceType">￥{{ getTaxPrice(scope.row) | thousandSymbol}}</span>
                  <span v-if="scope.row.pocmPriceType === '02'">￥0</span>
                </div>
                <div
                  class="price-msg"
                  v-if="scope.row.priceUnitQuantity !== 1 && scope.row.pocmPriceType === '01'"
                >(每{{ scope.row.priceUnitQuantity }}个商品{{ getTaxPrice(scope.row) | thousandSymbol}}元)</div>
                <div v-if="orderType !== 'shopSign' && orderType !== 'logistics'">运费: ￥{{ scope.row.extraFee || 0 | thousandSymbol}}</div>
                <div
                  class="price-msg"
                  v-if="scope.row.priceUnitQuantity !== 1 && scope.row.extraFee !== 0"
                >(每{{ scope.row.priceUnitQuantity | thousandSymbol}}个商品{{ scope.row.extraFee | thousandSymbol}}元)</div>
                <div>数量: {{ scope.row.purchaseQuantity | thousandSymbol}}</div>
                <div>小计: ￥{{ getItemSumPrice(scope.row) | thousandSymbol}}</div>
                <div v-if="orderType !== 'shopSign' && orderType !== 'logistics'">税额小计: ￥{{ getItemSumTaxPrice(scope.row) | thousandSymbol}}</div>
                <div
                  v-if="orderType !== 'shopSign' && orderType !== 'logistics'"
                >运费小计: ￥{{ getItemSumExtraPrice(scope.row) | thousandSymbol}}</div>
              </div>
              <!-- 印刷品图片上传 -->
              <div v-else>
                <div v-if="scope.row.isUpdate">
                  <div class="prints-img">
                    <el-upload
                      ref="upload"
                      :action="fileUploadTarget"
                      :on-success="handleImgSuccess"
                      :before-upload="checkBeforeUpload"
                      :before-remove="confirmImgRemove"
                      :on-exceed="handleExceed"
                      :headers="uploadHeaders"
                      :accept="'image/*'"
                      list-type="picture"
                      :file-list="scope.row.imageList"
                      multiple
                      style="overflow-y: auto"
                    >
                      <el-button class="btn-blue-plain" size="mini" @click="handleUpload(scope.$index)">上传预览图片</el-button>
                    </el-upload>
                  </div>
                  <div class="order-input">
                    <span class="list-text">AI文件百度云链接：</span>
                    <el-input size="mini" v-model="scope.row.printsFileUri"></el-input>
                  </div>
                  <div class="order-input">
                    <span class="list-text">商品备注：</span>
                    <el-input size="mini" v-model="scope.row.detailRemark"></el-input>
                  </div>
                </div>

                <div v-else>
                  <div class="prints-img">
                    <div>图片：</div>
                    <div
                      v-show="scope.row.detailPrintsList.length"
                      v-for="img in scope.row.detailPrintsList"
                      :key="img.imageFileId"
                      style="overflow-y: auto"
                    >
                      <img :src="getImageUrl(img.imageFileUri)" class="print-img cursor" @click="handlePreview(img.imageFileUri)" />
                    </div>
                    <div v-show="!scope.row.detailPrintsList.length">未上传</div>
                  </div>
                  <div class="prints-ai">AI文件百度云链接：{{ scope.row.printsFileUri }}</div>
                  <div>商品备注：{{ scope.row.detailRemark }}</div>
                </div>
                <el-button
                  size="mini"
                  class="btn-blue-plain"
                  @click="scope.row.isUpdate = !scope.row.isUpdate"
                  style="margin-top: 10px"
                  v-if="!scope.row.isUpdate"
                >再次更新</el-button>
                <el-button size="mini" class="btn-blue-plain" @click="printUpdate(scope.$index)" style="margin-top: 10px" v-else>提交更新</el-button>
              </div>
            </template>
          </el-table-column>
          <!-- 第四列区域 -->
          <el-table-column label="操作" width="140" v-if="orderType !== 'shopSign' && orderType !== 'logistics'">
            <template slot-scope="scope">
              <!-- 印刷品 -->
              <div v-if="scope.row.pocmDTO.isPrints">
                <div>单价(不含税): ￥{{ getPrice(scope.row) }}</div>
                <div
                  class="price-msg"
                  v-if="scope.row.priceUnitQuantity !== 1"
                >(每{{ scope.row.priceUnitQuantity | thousandSymbol}}个商品{{ getPrice(scope.row) | thousandSymbol}}元)</div>
                <div>
                  税额:
                  <span v-if="scope.row.pocmPriceType === '01' || !scope.row.pocmPriceType">￥{{ getTaxPrice(scope.row) | thousandSymbol}}</span>
                  <span v-if="scope.row.pocmPriceType === '02'">￥0</span>
                </div>
                <div
                  class="price-msg"
                  v-if="scope.row.priceUnitQuantity !== 1 && scope.row.pocmPriceType === '01'"
                >(每{{ scope.row.priceUnitQuantity | thousandSymbol}}个商品{{ getTaxPrice(scope.row) | thousandSymbol}}元)</div>
                <div>运费: ￥{{ scope.row.extraFee || 0 }}</div>
                <div
                  class="price-msg"
                  v-if="scope.row.priceUnitQuantity !== 1 && scope.row.extraFee !== 0"
                >(每{{ scope.row.priceUnitQuantity | thousandSymbol}}个商品{{ scope.row.extraFee | thousandSymbol}}元)</div>
                <div>数量: {{ scope.row.purchaseQuantity | thousandSymbol}}</div>
                <div>小计: {{ getItemSumPrice(scope.row) | thousandSymbol}}</div>
                <div>税额小计: ￥{{ getItemSumTaxPrice(scope.row) | thousandSymbol}}</div>
                <div>运费小计: ￥{{ getItemSumExtraPrice(scope.row) | thousandSymbol}}</div>
                <div>是否打样：￥{{ scope.row.isProof ? '是' : '否' }}</div>
              </div>
              <el-button
                class="btn-blue-plain"
                size="small"
                style="margin-top: 15px;margin-left: 20px"
                @click="getItemDetail(scope.row.itemId)"
              >商品详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 支付方式，报账实体 -->
      <div class="order-info-block">
        <el-row>
          <el-col :span="6" class="budget-info-block">
            <div class="block-title">预算归属</div>
            <div class="dotted-block text-center">
              <p>{{orderInfo.trKhCode||''}} - {{orderInfo.orgName||''}}</p>
              <!-- <p>{{ checkPayMethod(orderInfo) }}</p> -->
            </div>
          </el-col>

          <el-col :span="6" class="entity-info-block">
            <div class="block-title">工厂</div>
            <div class="dotted-block text-center">
              <p v-if="orderInfo.companyEntityDTO">{{ orderInfo.companyEntityDTO.entityCode }}</p>
              <p v-if="orderInfo.companyEntityDTO">{{ orderInfo.companyEntityDTO.entityName }}</p>
            </div>
          </el-col>

          <el-col :span="6" class="budget-info-block">
            <div class="block-title">成本中心</div>
            <div class="dotted-block text-center">
              <p v-if="orderInfo.baseCostCenterDTO">{{ orderInfo.baseCostCenterDTO.costCenterCode }}</p>
            </div>
          </el-col>

          <el-col :span="6" class="budget-info-block">
            <div class="block-title">采购组织</div>
            <div class="dotted-block text-center">
              <p>{{ orderInfo.purchaseOrg }}</p>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- sap信息 -->
      <div class="order-info-block" v-if="orderType === 'logistics'">
        <div class="block-title">SAP信息</div>

        <div class="block-content">
          <div class="block-content-row">
            <div>
              <div class="block-content-title">SAP PO创建时间：</div>
              <div class="block-content-text">{{ orderInfo.sapPoTime | parseTime('{y}-{m}-{d}') }}</div>
            </div>
            <div>
              <div class="block-content-title">SAP PO创建状态：</div>
              <div class="block-content-text">{{ getSapStatus(orderInfo.sapPoFlag) }}</div>
            </div>
            <div>
              <div class="block-content-title">SAP PO编号：</div>
              <div class="block-content-text">{{ orderInfo.poNumber }}</div>
            </div>
          </div>
          <div class="block-content-row">
            <div>
              <div class="block-content-title">SAP PO推送时间：</div>
              <div class="block-content-text">{{ orderInfo.syncSapTime | parseTime('{y}-{m}-{d}') }}</div>
            </div>
            <div>
              <div class="block-content-title">SAP PO推送状态：</div>
              <div class="block-content-text">{{ getSapStatus(orderInfo.syncSapFlag) }}</div>
            </div>
          </div>
          <div class="block-content-row">
            <div>
              <div class="block-content-title">SAP总数：</div>
              <div class="block-content-text">{{ sapInfo.sapTotalQuantity }}</div>
            </div>
            <div>
              <div class="block-content-title">SAP收货数量：</div>
              <div class="block-content-text">{{ sapInfo.sapGrQuantity }}</div>
            </div>
            <div>
              <div class="block-content-title">SAP收货状态：</div>
              <div class="block-content-text">{{ sapInfo.sapGrStatus === 'X' ? '已收货' : '' }}</div>
            </div>
          </div>
          <div class="block-content-row">
            <div style="width: 100%">
              <div class="block-content-title">SAP创建返回消息：</div>
              <div class="block-content-text">{{ orderInfo.sapPoMessage }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 收货信息 -->
      <div class="order-info-block" v-if="orderType !== 'shopSign' && orderType !== 'logistics'">
        <div class="block-title">收货信息</div>

        <el-table :data="deliveryTempList" class="delivery-table">
          <el-table-column label="商品名称" prop="itemName" />
          <el-table-column label="商品数量" prop="purchaseQuantity" width="100">
            <template slot-scope="scope">{{ scope.row.purchaseQuantity | thousandSymbol }}</template>
          </el-table-column>
          <el-table-column label="收货信息" min-width="120">
            <template slot-scope="scope">{{ getAddressInfo(scope.row) }}</template>
          </el-table-column>
          <el-table-column label="商品状态" prop="deliveryStatusName" />
          <el-table-column label="预计到货时间">
            <template v-if="scope.row.preFinishDate" slot-scope="scope">
              <span>{{ scope.row.preFinishDate | parseTime('{y}-{m}-{d}')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="SAP订单状态" prop="sapGrStatusName" />
          <el-table-column label="SAP收货数量" prop="sapGrQuantity" width="150" />
          <!-- <el-table-column label="快递单号" prop="logisticsNumber" min-width="150"/> -->
          <el-table-column label="快递单号" min-width="150">
            <template v-if="scope.row.logisticsNumber" slot-scope="scope">
              <span :title="scope.row.logisticsNumber">{{ scope.row.logisticsNumber.slice(0, 100) }}</span>
              <span v-if="scope.row.logisticsNumber.length > 100">...</span>
            </template>
          </el-table-column>
          <el-table-column label="快递公司" prop="logisticsCompanyName" />
          <el-table-column label="运输方式" prop="logisticsTypeName" />
          <el-table-column label="签收照片" prop="receiptImageUri">
            <template v-if="scope.row.receiptImageUri" slot-scope="scope">
              <div class="receipt-image">
                <div class="flexfile" v-if="scope.row.receiptImageUri.endsWith('.zip') || scope.row.receiptImageUri.endsWith('.rar')">
                  <i class="el-icon-document"></i>
                  <el-button type="primary" size="mini" round @click="handleViewFile(scope.row.receiptImageUri)">下载</el-button>
                </div>
                <img v-else :src="getImageUrl(scope.row.receiptImageUri)" @click="handleViewPic(scope.row.receiptImageUri)" />
              </div>
            </template>
          </el-table-column>
        </el-table>

        <div class="pag-row">
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="page"
            :page-size="pageSize"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>

      <!-- 订单备注 -->
      <div class="order-info-block">
        <el-row>
          <el-col :span="3">
            <div class="block-title">订单备注</div>
          </el-col>
          <el-col :span="21">
            <div class="order-remark">{{ orderInfo.orderRemark }}</div>
          </el-col>
        </el-row>
      </div>

      <!-- 订单信息 -->
      <div class="order-info-block order-info-box">
        <el-row>
          <el-col :span="3">
            <div class="block-title">订单信息</div>
          </el-col>
          <el-col :span="10">
            <div class="order-info-card">
              <div>订单编号：{{ orderInfo.orderNumber }}</div>
              <div>下单人：{{ orderInfo.createUserName }}</div>
              <div>下单时间：{{ orderInfo.orderDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</div>
              <div v-if="orderInfo.isUrgent !== null">下单方式：{{ orderInfo.isUrgent ? '加急下单' : '正常下单' }}</div>
              <!-- <div v-if="orderInfo.expectReceiveDate">预计收货日期：{{ orderInfo.expectReceiveDate | parseTime('{y}-{m}-{d}') }}</div> -->
              <div>SAP订单号：{{ orderInfo.poNumber }}</div>
              <div>SAP订单号生成时间：{{ orderInfo.sapPoTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</div>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="order-info-card card-red">
              <div>商品件数：{{ itemCount | thousandSymbol}}件</div>
              <div>运费金额：￥{{ orderInfo.extraAmount | thousandSymbol}}</div>
              <div>商品总价：￥{{ orderInfo.itemAmount | thousandSymbol}}</div>
              <div>实付金额：￥{{ orderInfo.orderAmount | thousandSymbol}}</div>
              <!-- <div class="amount-msg" v-if="orderInfo.urgentRatio">(选择加急下单方式，需额外支付{{ orderInfo.urgentRatio * 100 }}%加急费)</div> -->
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- BPM审批状态 -->
      <el-dialog :visible.sync="dialogVisible" width="70%">
        <div slot="title">
          <div class="notice-subject">BPM审批流程状态</div>
        </div>
        <div class="notice-content">
          <el-table :data="bpmStepList" class="delivery-table">
            <el-table-column label="审批单号" prop="bpmNum" />
            <el-table-column label="审批人" prop="approvalUser" />
            <el-table-column label="审批流程名" prop="processName" />
            <el-table-column label="节点名" prop="stepName" />
            <el-table-column label="审批时间" prop="approvalTime" />
            <el-table-column label="审批状态" prop="status" />
          </el-table>
        </div>
        <span slot="footer">
          <el-button class="btn-red" @click="dialogVisible = false">关 闭</el-button>
        </span>
      </el-dialog>
      <!-- 评价内容 -->
      <div class="order-info-block" v-if="evaluationList.length">
        <div class="block-title">评价</div>
        <div class="eval-content">
          <el-row
            class="eval-item"
            :class="{'eval-item-bottom':index !== evaluationList.length - 1}"
            v-for="(evaluation,index) in evaluationList"
            :key="evaluation.evaluateId"
          >
            <el-col class="avatar-info" :span="2" :offset="2">
              <el-image :src="getImageUrl(evaluation.avatarImageUri)" alt />
              <span>{{evaluation.createName}}</span>
            </el-col>
            <el-col class="eval-detail" :span="18" :offset="1">
              <div class="eval-rate">
                物料质量:
                <span>{{evaluation.qualityScore + '.0'}}</span>
                物料外观:
                <span>{{evaluation.appearanceScore + '.0'}}</span>
                物流服务:
                <span>{{evaluation.serviceScore + '.0'}}</span>
              </div>
              <p v-if="evaluation.scoreContent" class="eval-text">{{evaluation.scoreContent}}</p>
              <p v-else>您没有填写文字评价！</p>
              <div v-viewer="{ movable: true }" class="eval-imgList" v-if="evaluation.purchaseOrderEvaluateImageList.length">
                <el-image
                  :src="getImageUrl(imgItem.imageFileUri)"
                  v-for="imgItem in evaluation.purchaseOrderEvaluateImageList"
                  :key="imgItem.imageFileId"
                  alt
                />
              </div>
              <div class="goods-info">
                <span class="goods-info-name">{{orderInfo.detailList[index].itemName}}</span>
                <span class="eval-time">{{evaluation.scoreTime | parseTime("{y}-{m}-{d} {h}:{i}")}}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import OrderStatusStep from './components/order-status-step'
import OrderItemInfoNonMenu from './components/order-item-info-non-menu'
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
import { tokenUtils } from '@/utils/auth'
import { mapState } from 'vuex'
import baseApi from '@/api/base'
import orderApi from '@/api/order'
const math = create(all)
export default {
  name: 'order-info',
  components: {
    ContentHeader,
    OrderStatusStep,
    OrderItemInfoNonMenu
  },
  data () {
    return {
      loading: false,
      orderInfo: {},
      orderType: '',
      deliveryList: [],
      totalAmount: 0,
      itemIndex: null,
      itemCount: 0,
      dialogVisible: false,
      bpmStepList: [],
      page: 1,
      pageSize: 5,
      total: null,
      deliveryTempList: [],
      evaluationList: [],
      evaluationForm: {
        orderId: '',
        itemIdList: ''
      },
      purchaseEstimate: {},
      sapInfo: {}
    }
  },
  computed: {
    ...mapState({
      fileUploadTarget: state => state.app.fileUploadTarget
    }),
    uploadHeaders () {
      return {
        Authorization: 'Bearer ' + tokenUtils.getToken(true),
        Accept: 'application/json'
      }
    },
    navPathInfo () {
      let pathInfo = {}
      switch (this.orderType) {
        case 'menu':
          pathInfo = { path: '/order/list/pocm', name: 'POCM订单' }
          break
        case 'printing':
          pathInfo = { path: '/order/list/pocm', name: 'POCM订单' }
          break
        case 'nonMenu':
          pathInfo = { path: '/order/list/non-menu', name: 'Non-Menu订单' }
          break
        case 'freezer':
          pathInfo = { path: '/order/list/freezer', name: '资产管理订单' }
          break
        case 'shopSign':
          pathInfo = { path: '/order/list/shop-sign', name: '店招订单' }
          break
        case 'logistics':
          pathInfo = { path: '/order/list/logistics', name: '物流费订单' }
          break
        default:
          break
      }
      return [
        {
          path: '/order/list/pocm',
          name: '订单中心'
        },
        pathInfo
      ]
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.orderType = this.$route.query.orderType
      this.queryOrderById()
    },

    // 获取订单详情
    queryOrderById () {
      this.loading = true
      this.$store.dispatch('queryOrderInfo', this.$route.query.orderId).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.orderInfo = res.data.resultData.purchaseOrderDTO
          this.evaluationForm.orderId = this.orderInfo.orderId
          this.orderInfo.detailList.forEach(item => {
            this.evaluationForm.itemIdList += item.itemId + ','
            this.$set(item, 'imageList', [])
            this.$set(item, 'isUpdate', false)
            this.showImg(item)
            let status = this.getSapGrStatusName(item)
            if (this.orderType !== 'shopSign') {
              if (item.deliveryList?.length) {
                item.deliveryList.forEach(list => {
                  this.$set(list, 'sapGrQuantity', item.sapGrQuantity)
                  this.$set(list, 'sapGrStatusName', status)
                })
              }
            }
          })
          this.evaluationForm.itemIdList = this.evaluationForm.itemIdList.substr(0, this.evaluationForm.itemIdList.length - 1)
          if (this.orderType === 'menu' || this.orderType === 'printing') {
            this.queryEvaluationList()
            this.queryPurchaseEstimate()
          }
          this.getTotalAmount()
          this.getDeliveryList()
          this.getItemCount()
          if (this.orderInfo.detailList?.length) {
            this.sapInfo = this.orderInfo.detailList[0] || {}
          }
        }
      }).catch(() => {
        this.loading = false
      })
    },
    // 获取预计收货时间
    queryPurchaseEstimate () {
      let itemIdList = ''
      this.orderInfo.detailList.forEach(item => {
        itemIdList += item.pocmDTO.itemId + ','
      })
      orderApi.queryPurchaseEstimate({ itemIdList: itemIdList }).then(res => {
        if (res.data.resultCode === '0') {
          this.purchaseEstimate = res.data.resultData.estimateDate
          // for (let i in this.purchaseEstimate) {
          //   this.EstimateDate += this.purchaseEstimate[i]
          // }
          // let currentDate = Date.parse(new Date())
          // this.EstimateDate = currentDate + this.EstimateDate * (86400 * 1000)
          // this.orderForm.purchaseOrder.expectReceiveDate = this.EstimateDate
        }
      })
    },
    getTotalAmount () {
      this.totalAmount = 0
      this.orderInfo.detailList.map(item => {
        this.totalAmount = commonUtils.formatNumber(math.add(
          this.totalAmount,
          math.multiply(item.purchasePrice, item.purchaseQuantity / item.priceUnitQuantity)
        )).toFixed(2)
      })
      this.totalAmount = Number(this.totalAmount) ? this.totalAmount : 0.01
    },

    getItemCount () {
      this.itemCount = 0
      this.orderInfo.detailList.forEach(item => {
        this.itemCount += item.purchaseQuantity
      })
    },

    getSapStatus (val) {
      let statusList = ['未创建', '已创建', '创建失败']
      return statusList[val]
    },

    // sap订单状态
    getSapGrStatusName (item) {
      if (!item.sapGrQuantity) {
        return ''
      } else if (item.sapGrQuantity < item.sapTotalQuantity) {
        return '部分收货'
      } else if (item.sapGrQuantity === item.sapTotalQuantity) {
        return '全部收货'
      } else {
        return ''
      }
    },

    // BPM审批流程状态
    showBPMStatus () {
      this.$store.dispatch('getBPMstatus', this.orderInfo.orderNumber).then(res => {
        if (res.data.resultCode === '0') {
          if (!res.data.resultData) {
            this.$message.error('BPM审批流程为空')
            return
          }
          this.bpmStepList = res.data.resultData.bpmStepList
          this.dialogVisible = true
        }
      })
    },

    // 获取SAP订单收货状态
    getSAPStatus () {
      this.loading = true
      this.$store.dispatch('getSAPStatus', this.orderInfo.poNumber).then(res => {
        if (res.data.resultCode === '0') {
          setTimeout(() => {
            this.init()
            this.$message.success('SAP订单收货状态更新成功')
          }, 3000)
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('SAP订单收货状态更新失败')
      })
    },

    // 获取订单地址
    getDeliveryList () {
      this.deliveryList = []
      this.orderInfo.detailList.map(item => {
        this.deliveryList = this.deliveryList.concat(item.deliveryList)
      })
      this.setPage()
    },

    // 上传前检测
    checkBeforeUpload (file) {
      if (file.type.substr(0, 5) !== 'image') {
        this.$message.error('上传的文件不是图片文件，请重新上传')
        return false
      }
    },

    // 上传图片成功
    handleImgSuccess (res) {
      if (res.resultCode === '0') {
        this.$message.success('上传图片成功')
        this.orderInfo.detailList[this.itemIndex].detailPrintsList.push({ imageFileId: res.resultData.fileDTO.fileId })
      }
    },

    handleUpload (index) {
      this.itemIndex = index
    },

    // 删除图片
    confirmImgRemove (file) {
      if ((file && file.response && file.response.resultData && file.response.resultData.fileDTO) || file.imageFileId) {
        const fileId = file.response
          ? file.response.resultData.fileDTO.fileId
          : file.imageFileId
        baseApi.deleteFile({ fileId: fileId }).then(res => {
          if (res.data.resultCode === '0') {
            this.$message.warning('删除图片成功')
            this.orderInfo.detailList.forEach(item => {
              item.detailPrintsList.forEach((img, index) => {
                if (img.imageFileId === fileId) {
                  item.detailPrintsList.splice(index, 1)
                }
              })
            })
          }
        })
      }
    },

    // 更新印刷品订单内容
    printUpdate (index) {
      let printsFiles = []
      this.orderInfo.detailList[index].detailPrintsList.forEach(img => {
        printsFiles.push(img.imageFileId)
      })
      let params = {
        detailId: this.orderInfo.detailList[index].detailId,
        detailRemark: this.orderInfo.detailList[index].detailRemark,
        printsFileUri: this.orderInfo.detailList[index].printsFileUri,
        printsFiles: printsFiles.join(',')
      }
      this.$store.dispatch('uploadPrintsOrder', params).then(res => {
        if (res.data.resultCode === '0') {
          this.$message.success('更新数据成功')
          this.queryOrderById()
        }
      })
    },

    // 查看商品详情
    getItemDetail (id) {
      this.$router.push({ path: `/material/item-detail/${id}` })
    },

    // 获取间隔时间
    getInterval (time) {
      let date = new Date().getTime()
      let intervalDate = date - time
      return Math.floor(intervalDate / 86400000) + 1
    },

    handleExceed () { },

    // 商品小计   未税价*数量
    getItemSumPrice (item) {
      if (!item || !item.taxExcludedPrice || !item.purchaseQuantity || !item.priceUnitQuantity) {
        return ''
      }
      let price = item.taxExcludedPrice
      let sum = commonUtils.formatNumber(
        math.multiply(price, item.purchaseQuantity / item.priceUnitQuantity)
      ).toFixed(2)
      sum = Number(sum)
      return sum
    },
    // 税额小计   (采购价-未税价)*数量
    getItemSumTaxPrice (item) {
      if (!item) return ''
      if (item.pocmPriceType === '02') return 0
      let taxPrice = commonUtils.formatNumber(math.multiply((item.purchasePrice - item.taxExcludedPrice), item.purchaseQuantity / item.priceUnitQuantity)).toFixed(2)
      if (Number(taxPrice) < 0.01) taxPrice = 0.00
      return taxPrice
    },
    // 额外费用合计   一般menu物料 未税价格*加急比例*数量
    getItemSumExtraPrice (item) {
      if (!item) {
        return ''
      }

      let categoryCode = item.pocmDTO.itemCategory.categoryCode || ''

      if (categoryCode && (categoryCode !== 'prints') && (categoryCode !== 'lybg')) {
        // 普通商品
        if (item.extraFee > 0) {
          let price = math.multiply(item.taxExcludedPrice, this.orderInfo.urgentRatio)
          item.sumPrice = commonUtils.formatNumber(math.multiply(price, (item.purchaseQuantity / item.priceUnitQuantity))).toFixed(2)
          item.sumPrice = Number(item.sumPrice)
          return item.sumPrice
        } else {
          return 0
        }
      } else if (categoryCode && categoryCode === 'lybg') {
        // 冰柜
        item.sumPrice = commonUtils.formatNumber(math.multiply(item.extraFee, (item.purchaseQuantity / item.priceUnitQuantity))).toFixed(2)
        item.sumPrice = Number(item.sumPrice)
        return item.sumPrice
      } else {
        return 0
      }
    },
    // // 额外费用合计    商品运费*数量
    // getItemSumExtraPrice (item) {
    //   if (!item) {
    //     return ''
    //   }
    //   if (!item.extraFee) item.extraFee = 0
    //   item.sumPrice = commonUtils.formatNumber(math.multiply(item.extraFee, item.purchaseQuantity / item.priceUnitQuantity)).toFixed(2)
    //   item.sumPrice = Number(item.sumPrice)
    //   return item.sumPrice
    // },

    showImg (info) {
      info.imageList = []
      info.detailPrintsList.forEach(img => {
        const url = this.getImageUrl(img.imageFileUri)
        info.imageList.push({ name: img.imageName, url: url, imageFileId: img.imageFileId })
      })
    },

    handlePreview (url) {
      window.open(commonUtils.getImageUrl(url))
    },

    getItemImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    },

    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    },

    checkPayMethod (info) {
      if (info.quotaId) {
        return `  TR: ${info.quotaName}`
      } else {
        return `TR：${info.trKhCode}`
      }
    },

    getAddressInfo (row) {
      if (row.provinceName) {
        return `${row.provinceName}-${row.cityName}-${row.countyName}-${row.detailAddress}，${row.receivePerson}: ${row.receivePhone}`
      } else {
        return row.addressInfo
      }
    },

    getPrice (item) {
      if (!item.taxExcludedPrice) return
      return (item.taxExcludedPrice).toFixed(2)
    },
    // 计算税额
    getTaxPrice (item) {
      return (item.taxRate * item.taxExcludedPrice).toFixed(2)
    },

    setPage () {
      this.total = this.deliveryList.length
      this.pageLoadData(1)
    },

    // 分页
    pageLoadData (page) {
      this.deliveryTempList = this.deliveryList.slice((page - 1) * this.pageSize, page * this.pageSize)
    },

    handleCurrentChange (val) {
      this.pageLoadData(val)
    },

    getBrandName (row) {
      if (row.subBrandName) {
        return row.abiBrandName + ' - ' + row.subBrandName
      }
      return row.abiBrandName
    },
    getChannelName (row) {
      if (row.subChannelName) {
        return row.channelName + ' - ' + row.subChannelName
      }
      return row.channelName
    },

    handleViewPic (uri) {
      window.open(this.getImageUrl(uri))
    },
    handleViewFile (uri) {
      window.open(commonUtils.getFileUrl(uri))
    },
    // 跳转评价页
    toEvaluation () {
      localStorage.setItem('orderInfo', JSON.stringify(this.orderInfo))
      this.$router.push({
        path: '/order/evaluation'
      })
    },
    // 获取评论
    queryEvaluationList () {
      orderApi.queryEvaluationList(this.evaluationForm).then(res => {
        if (res.data.resultCode) {
          this.evaluationList = res.data.resultData.purchaseOrderEvaluateDTOList
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.order-info-block {
  border-radius: 10px;
  background-color: $base-white;
  padding: 20px;
  margin-bottom: 20px;

  .block-title {
    line-height: 32px;
  }
}
.order-header {
  .order-number {
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
  }
  .order-date {
    font-size: 16px;
    line-height: 30px;
  }
  .ongoing {
    margin-left: 15px;
  }
  .order-status {
    color: $base-red;
    padding: 16px 0;
  }
}

.order-detail {
  width: 100%;
  .item-image {
    width: 65px;
    height: 65px;
    margin: 0 auto;
    border: 1px solid $base-grey;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    img {
      max-width: 90%;
      max-height: 90%;
    }
  }

  .item-name {
    text-align: left;
    font-weight: 700;
  }

  .item-sum {
    font-weight: 700;
  }
}

.order-amount {
  border: 2px dashed #db3e3e;
  margin: 10px 0 0 0;
  padding: 0 20px;
  color: #db3e3e;
  font-size: 16px;
  line-height: 32px;
}

.dotted-block {
  border: 2px dashed $base-grey3;
  vertical-align: middle;
  height: 80px;
}

.budget-info-block {
  padding: 0 30px 0 0;
  p {
    margin-top: 30px;
  }
}
.entity-info-block {
  padding: 0 30px 0 0;
  p {
    margin-top: 15px;
    & + p {
      margin-top: -5px;
    }
  }
}

.delivery-table {
  ::v-deep th {
    background-color: $base-grey3;
  }

  .receipt-image {
    width: 60px;
    height: 60px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    .flexfile {
      display: flex;
      flex-direction: column;
      align-items: center;
      i {
        font-size: 20px;
        margin-bottom: 10px;
      }
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}

.order-remark {
  line-height: 32px;
}

.order-info-box {
  .order-info-card {
    width: 400px;
    height: 190px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 0 40px;
    div {
      margin-top: 9px;
    }
    &.card-red {
      border-color: $base-red;
      color: $base-orange;
      padding: 30px 0 0 130px;
      div {
        margin-top: 15px;
      }
    }
    .amount-msg {
      color: #333;
      font-size: 12px;
      margin-top: 5px !important;
    }
  }
}
.list-text {
  padding-bottom: 5px;
  display: inline-block;
}
.order-input {
  display: flex;
  margin: 10px 0;
  .el-input {
    width: 200px;
  }
}
.prints-img {
  display: flex;
  align-items: center;
  .print-img {
    width: 40px;
    height: 40px;
    margin-right: 5px;
  }
}
.prints-ai {
  margin: 10px 0;
}
.prints-info {
  & > div {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.SAP-btn {
  text-align: right;
  margin-bottom: 15px;
}
.price-msg {
  margin-top: -5px;
}
.price-info {
  font-size: 12px;
  color: #999;
}

.block-content {
  .block-content-row {
    display: flex;
    box-sizing: border-box;
    padding-left: 10px;

    & > div {
      width: 33%;
      display: flex;
      margin-top: 12px;

      .block-content-title {
        width: 130px;
        text-align: right;
      }

      .block-content-text {
        color: #666;
      }
    }
  }
}
.eval-content {
  .eval-item {
    padding-bottom: 20px;
  }
  .eval-item-bottom {
    border-bottom: 1px solid #ebeef5;
  }
}
.eval-imgList {
  margin-bottom: 10px;
  cursor: pointer;
}
.el-image {
  width: 50px;
  height: 50px;
}
.avatar-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  .el-image {
    margin: 20px 0 10px 0;
  }
}
.goods-info {
  display: flex;
  justify-content: space-between;
}
.eval-detail {
  padding-top: 25px;
  .eval-rate {
    span {
      color: #c8102d;
      margin-left: 5px;
      margin-right: 30px;
      font-weight: 700;
    }
  }
}
.EstimateDate-detail {
  display: inline-block;
  width: 14px;
  height: 14px;
  font-size: 14px;
  border: 3px solid #c8102d;
  border-radius: 50%;
  text-align: center;
  line-height: 15px;
  color: #c8102d;
  font-weight: 700;
  position: relative;
  // top: -5px;
  cursor: pointer;
  margin-left: 15px;
}
.EstimateDate {
  padding: 12px;
  .title {
    font-weight: 700;
    font-size: 15px;
    padding-bottom: 8px;
    border-bottom: 1px dashed #ccc;
  }
  ul {
    margin-bottom: 0;
    padding-left: 20px;
  }
}
</style>
